<div class="formfield nes-flex nes-flex-col nes-w-full">
  <label class="nes-p-0 nes-w-full nes-text-form-label nes-font-bold nes-font-sans nes-text-left nes-mb-2" for="employeeAmountSelect">
    {{ "COMPANY_DATA.INPUT.EMPLOYEES.LABEL" | translate }}
  </label>
  <div class="formfield__inputContainer nes-w-full nes-ml-0 nes-pl-0">
    <select
      class="select textInput--fullWidth"
      id="employeeAmountSelect"
      [cypress]="'employee_amount'"
      (ngModelChange)="selected.emit($event)"
      [(ngModel)]="employeeAmount"
    >
      <option
        *ngFor="let segment of segments"
        [disabled]="segment.value === 0"
        [value]="segment.value"
        privacySensitive
      >
        {{ segment.displayText | translate }}
      </option>
    </select>
    @if (employeeRequiredError) {
      <nes-error-message>
        {{ employeeRequiredError }}
      </nes-error-message>
    }
  </div>
</div>
